<template>
	<div
		:class="[
			'filters-container',
			'animate__animated',
			'animate__faster',
			ui.animation,
		]"
	>
		<!-- Filter Category -->
		<div v-for="filter in ui.filters" class="filter">
			<span class="filter-name">
				{{ `${filter.title}:` }}
			</span>

			<!-- Filter Options -->
			<div class="d-flex flex-column mt-1">
				<div
					v-for="option in filter.options"
					@click="optionToggle(option)"
					:class="[
						'option',
						{
							'option-active': option.ui.active,
						},
					]"
				>
					{{ option.name }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import { EventBus } from "@/main";
import Quality from "@/components/Article/Quality";
import axios from "axios";

export default {
	components: { Quality },

	data() {
		return {
			data: {
				categories: [],

				query: {
					categories: [],
				},
			},

			ui: {
				animation: "animate__fadeIn",

				filters: [],
			},
		};
	},

	mounted() {
		if (this.$route.query.categories) {
			this.data.query.categories = this.$route.query.categories;
		}

		EventBus.$on("critetionChanged", (criterion) => {});

		this.getCategories();
	},

	methods: {
		async getCategories() {
			try {
				await this.$store.dispatch("getCategories");

				let parentCategories = this.categories.filter(
					(item) => item.category_id === null
				);

				this.ui.filters.unshift({
					title: "Productos",
					name: "category",
					options: this.mapCategories(parentCategories),
					ui: {
						justOneOption: true,
					},
				});
			} catch (error) {
				EventBus.$emit("Error", {
					error: error,
					errorsShow: true,
				});
			}
		},

		mapCategories(categories) {
			let items = [];

			categories.forEach((category) => {
				items.push({
					value: category.id,
					name: category.name,
					ui: {
						active: this.data.query.categories.includes(
							category.id
						),
					},
				});
			});

			return items;
		},

		optionToggle(option) {
			const value = !option.ui.active;

			this.ui.filters[0].options.forEach((item) => {
				item.ui.active = false;
			});

			option.ui.active = value;

			this.filtersActive();
		},

		filtersActive() {
			let filtersActive = [];

			let activeOptions = this.ui.filters[0].options.filter(
				(option) => option.ui.active
			);

			let filters = {
				category: activeOptions.map((option) => option.value),
			};

			this.$store.commit("SET_FILTERS", filters);
		},
	},

	computed: {
		...mapState({
			filters: (state) => state.filters,

			categories: (state) => state.categories,

			type_of_finishes: (state) => state.type_of_finishes,

			criterion: (state) => state.criterion,
		}),
	},
};
</script>

<style lang="css" scoped>
.v-card--reveal {
	align-items: center;
	bottom: 0;
	justify-content: center;
	opacity: 0.5;
	position: absolute;
	width: 100%;
}

.option {
	position: relative;
	cursor: pointer;
	font-size: 14px;
	display: flex;
	color: #555;
	height: 55px;
	padding-left: 15px;
	align-items: center;
	transition: all 0.3s;
	border-bottom: 1px solid rgba(0, 0, 0, 0.07);
}

.option::after {
	content: "";
	position: absolute;
	left: 0;
	top: 0;
	width: 4px;
	height: 100%;
	background-color: transparent;
}

.option,
.option *::selection {
	background: transparent;
	text-shadow: none;
}

.filter {
	display: flex;
	flex-direction: column;
	margin-bottom: 5px;
}

.filter .option:hover {
	color: #005db9;
	background-color: rgba(0, 0, 0, 0.07);
}

.filter-name {
	padding-left: 10px;
	letter-spacing: 1px;
	font-weight: 600;
	color: #000;
	text-transform: uppercase;
}

.option-active {
	background-color: rgba(0, 0, 0, 0.07);
	font-weight: 600;
	color: #005db9 !important;
}

.option-active::after {
	background-color: #005db9;
}

.child-option-active {
	background-color: rgba(0, 0, 0, 0.05);
}

.categories-container {
	display: flex;
	flex-wrap: wrap;
}
.category {
	padding: 2px 7px;
	font-size: 12px;
	border: 1px solid #ddd;
	background-color: #eee;
	position: relative;
	cursor: pointer;
}

.check-active-option {
	font-size: 1.2rem;
}

.chevron {
	transition: all 0.3s;
	color: #bbb;
}

.chevron-rotate {
	transform: rotate(180deg);
	color: #999;
}

/*Extra small < 600px*/
@media (min-width: 0) and (max-width: 960px) {
}

/*Medium	md	Large tablet to laptop	960px > < 1264px**/
@media (min-width: 961px) and (max-width: 1264px) {
}

/*Large	lg	Desktop	1264px > < 1904px**/
@media (min-width: 1265px) and (max-width: 1904px) {
}

/*Extra large	xl	4k and ultra-wide*/
@media (min-width: 1904px) {
}
</style>
